import React from 'react';

/**
 * StepIndicator - Reusable numbered step badge component
 *
 * Features:
 * - Circular numbered badge
 * - Title and optional description
 * - Consistent styling across templates
 *
 * @param {object} props
 * @param {number} props.number - Step number to display
 * @param {string} props.title - Step title
 * @param {React.ReactNode} props.children - Step content
 * @param {string} props.marginBottom - Optional bottom margin (default: '2rem')
 * @param {string} props.contentPadding - Optional content padding (default: '2.75rem')
 */
function StepIndicator({
  number,
  title,
  children,
  marginBottom = '2rem',
  contentPadding = '2.75rem'
}) {
  return (
    <div style={{ marginBottom }}>
      {/* Step Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        marginBottom: '1rem'
      }}>
        {/* Step Number Badge */}
        <div style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          background: '#3b82f6',
          color: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 'var(--font-xxs)',
          fontWeight: '700',
          flexShrink: 0
        }}>
          {number}
        </div>

        {/* Step Title */}
        <h3 style={{
          margin: 0,
          fontSize: 'var(--font-sm)',
          fontWeight: '600',
          color: '#1e293b'
        }}>
          {title}
        </h3>
      </div>

      {/* Step Content */}
      <div style={{
        paddingLeft: contentPadding
      }}>
        {children}
      </div>
    </div>
  );
}

export default StepIndicator;
